import { render } from "./SplashView.vue?vue&type=template&id=410c4237&scoped=true"
const script = {}

import "./SplashView.vue?vue&type=style&index=0&id=410c4237&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-410c4237"]])

export default __exports__